<template>
  <div class="container max-w-full mx-auto md:py-4 px-6 text-gray-800"></div>
</template>

<script>
export default {
  mounted() {
    const data = {
      id: this.$route.params.id,
      hash: this.$route.params.hash,
      params: this.$route.query
    }
    this.$store
      .dispatch('TOKEN_CONFIRMATION', data)
      .then(response => {
        this.$toasted.success('Tudo Certo! Conta confirmada com sucesso!', {
          position: 'top-center',
          duration: 5000,
          icon: 'check'
        })
        this.$router.push({ name: 'login' })
      })
      .catch(error => {
        this.$toasted.error(
          'Algo Errado! Token de confirmação não encontrado ou ja confirmado!',
          {
            position: 'top-center',
            duration: 5000,
            icon: 'close'
          }
        )
        this.$router.push({ name: 'login' })
        console.error(error)
      })
  }
}
</script>

<style></style>
